import React from 'react';

interface FaviconProps {
  size?: number;
  className?: string;
}

// Gros flocon de neige monochrome (utilisable comme favicon froid)
export const SnowflakeIcon: React.FC<FaviconProps> = ({ size = 24, className = '' }) => {
  const dimension = `${size}px`;

  return (
    <svg data-component-id="src/components/ui/ServiceFavicon.tsx:13:4" data-component-path="src/components/ui/ServiceFavicon.tsx" data-component-line="13" data-component-file="ServiceFavicon.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D"
      width={dimension}
      height={dimension}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* branches principales */}
      <line data-component-id="src/components/ui/ServiceFavicon.tsx:25:6" data-component-path="src/components/ui/ServiceFavicon.tsx" data-component-line="25" data-component-file="ServiceFavicon.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="12" y1="2" x2="12" y2="22" />
      <line data-component-id="src/components/ui/ServiceFavicon.tsx:26:6" data-component-path="src/components/ui/ServiceFavicon.tsx" data-component-line="26" data-component-file="ServiceFavicon.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="2" y1="12" x2="22" y2="12" />
      <line data-component-id="src/components/ui/ServiceFavicon.tsx:27:6" data-component-path="src/components/ui/ServiceFavicon.tsx" data-component-line="27" data-component-file="ServiceFavicon.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="4.5" y1="4.5" x2="19.5" y2="19.5" />
      <line data-component-id="src/components/ui/ServiceFavicon.tsx:28:6" data-component-path="src/components/ui/ServiceFavicon.tsx" data-component-line="28" data-component-file="ServiceFavicon.tsx" data-component-name="line" data-component-content="%7B%22elementName%22%3A%22line%22%7D" x1="19.5" y1="4.5" x2="4.5" y2="19.5" />
      {/* centre */}
      <circle data-component-id="src/components/ui/ServiceFavicon.tsx:30:6" data-component-path="src/components/ui/ServiceFavicon.tsx" data-component-line="30" data-component-file="ServiceFavicon.tsx" data-component-name="circle" data-component-content="%7B%22elementName%22%3A%22circle%22%7D" cx="12" cy="12" r="1.8" fill="currentColor" />
    </svg>
  );
};

